/**
 *
 * @param value number 타입 원화(₩)를 인자로 받습니다.
 * @returns string 타입 "~원"을 리턴합니다.
 */
export const formatCurrency = (value: number) => `${value.toLocaleString()}원`
